<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="aliasForm" *ngIf="aliasForm !== null">
		<div class="grid">
			<div [ngClass]="col12Responsive()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.stateOn, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.stateOn, 'label')">{{ 'RBE_STATE_HIGH_LABEL' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.stateOn, 'borderInput')">
						<input type="text" pInputText [formControlName]="'stateOn'" maxlength="50"
							[ngClass]="dynamicInputTextWidth()" />
						<p-button pTooltip="{{ 'RESTORE_DEFAULT' | translate }}" tooltipPosition="bottom"
							icon="pi cm-reload" styleClass="p-1" (click)="restoreDefault('stateOn')"
							[rounded]="false" [text]="true" severity="danger" type="button">
						</p-button>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.stateOn)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'INVALID_NAME' | translate }}</small>
			</div>
			<div [ngClass]="col12Responsive()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.stateOff, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.stateOff, 'label')">{{ 'RBE_STATE_LOW_LABEL' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.stateOff, 'borderInput')">
						<input type="text" pInputText [formControlName]="'stateOff'" maxlength="50"
							[ngClass]="dynamicInputTextWidth()" />
						<p-button pTooltip="{{ 'RESTORE_DEFAULT' | translate }}" tooltipPosition="bottom"
							icon="pi cm-reload" styleClass="p-1" (click)="restoreDefault('stateOff')"
							[rounded]="false" [text]="true" severity="danger" type="button">
						</p-button>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.stateOff)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'INVALID_NAME' | translate }}</small>
			</div>
		</div>
		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1"
				[disabled]="automationAliasEditing" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>
